<div class="summary-container">
	<app-summary-header [siteInfo]="siteInfo" [totalDevices]="totalDevices" [period]="period" [selectedPeriod]="selectedPeriod"></app-summary-header>
	<app-performance-score-widget [data]="sitePerformanceScores" [devices]="devices" [toPrint]="true" [period]="period"></app-performance-score-widget>
	<div class="content-grid">
		<app-avg-daily-usage [report]="usagePerformanceData" [period]="period" [devices]="devices" [weeksOfOperation]="numOfWeeks"></app-avg-daily-usage>
		<app-battery-performance-metrics [siteChargingType]="siteChargingType" [batteryPerformanceMetrics]="batteryPerformanceMetrics" [chargingMetrics]="chargingMetrics"></app-battery-performance-metrics>
	</div>
</div>